"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEADERS = void 0;
const HEADERS = exports.HEADERS = ['Программа', 'Ставка', 'Сумма', 'Срок', 'Ежемесячный платёж'];